import classNames from 'classnames'
import React from 'react'
import { s_schedule_enter } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import Badge from '../Badge'
interface CreditBadgeType {
  duration: string | number
  label?: string
  isMakeUpCredit?: boolean
  clx?: any
  style?: any
}
const CreditBadgeSkeleton = () => {
  return <div className={classNames('h-[26px] w-[46px] animate-pulse rounded-md bg-gray-100')}></div>
}
const CreditBadge: React.FC<CreditBadgeType> = ({ duration, label = '', isMakeUpCredit, ...props }) => {
  const { t } = useTranslation()
  const { clx, style } = props
  const is40M = duration == 40

  const showSkeleton = !duration
  if (showSkeleton) {
    return <CreditBadgeSkeleton />
  }
  return (
    <Badge
      disabled={isMakeUpCredit}
      style={style}
      fortyLight={!isMakeUpCredit && is40M}
      twentyLight={!isMakeUpCredit && !is40M}
      clx={clx}
    >
      {label ? label : duration}
      {label.length === 0 && t(s_schedule_enter.min)}
    </Badge>
  )
}

export default CreditBadge
